import React from 'react';
import { Link } from 'react-router-dom';

export const Logo = ({ className = "" }) => {
  return (
    <Link to="/" className={`flex items-center gap-3 ${className}`}>
      {/* Modern Minimalist Finance Logo */}
      <img 
        src="/img/logo-loanyard.png" 
        alt="LOANYARD CAPITAL — corporate finance advisory logo"
        width="56"
        height="56"
        className="h-14 w-14 object-contain"
      />
      {/* Company Name Text - LOANYARD in Black, CAPITAL in Green */}
      <div className="flex flex-col">
        <span className="text-xl font-bold tracking-tight leading-tight">
          <span className="text-slate-900">LOANYARD</span> <span className="text-emerald-600">CAPITAL</span>
        </span>
        <span className="text-xs text-slate-500 font-medium">Funding your ambitions</span>
      </div>
    </Link>
  );
};